import _extends from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { Text } from 'rebass/styled-components';
import { space, width, fontSize } from 'styled-system';
import { mediaQueries } from 'shared/styles';
import useStores from 'shared/hooks/use-stores';
import { Button, StyledLink, DesktopOnly, MobileOnly } from 'shared/components';
import { ModalContainer } from 'shared/modals/v2-container';
import { RewardsRibbon, RibbonColorPallettes } from 'shared/assets/rewards-ribbon';
var AlpineIQTerms = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onAgree = _ref.onAgree,
    onDecline = _ref.onDecline,
    containerProps = _ref.containerProps;
  var _useStores = useStores(),
    Cart = _useStores.Cart;
  var dispensary = Cart.order.dispensary;
  if (!dispensary) {
    return;
  }

  // eslint-disable-next-line consistent-return
  return __jsx(StyledModalContainer, _extends({
    ref: ref,
    mobileCentered: true,
    isOpen: true
  }, containerProps), __jsx(ModalContent, {
    id: "asdfasdf"
  }, __jsx(DesktopOnly, null, __jsx(RewardsRibbon, {
    pallette: RibbonColorPallettes.blue,
    height: 106,
    width: 106
  })), __jsx(MobileOnly, null, __jsx(RewardsRibbon, {
    pallette: RibbonColorPallettes.blue,
    height: 86,
    width: 86
  })), __jsx(TitleText, null, "Terms of Use"), __jsx(TermsText, null, "I consent to signup for the ", dispensary.name, " ", Cart.rewardsProgramDisplayName, " program where I will receive marketing communications. By doing so, I understand that I am allowing ", dispensary.name, " and its technology provider(s) to retain my personal contact details/engagement history for use in personalized marketing. Opt out at any time by replying \"STOP\" to messages. Standard message and calling rates may apply."), __jsx(StyledAgreeButton, {
    id: "alpineIqAgreeToTermsButton",
    onClick: onAgree,
    "data-cy": "save-button",
    "data-test": "save-button"
  }, "Agree & Continue"), __jsx(StyledLink, {
    as: "button",
    fontSize: "13px",
    onClick: onDecline
  }, "No thanks, not now")));
});
export default AlpineIQTerms;
var modalContainerStyles = css(["height:499px;width:550px;padding:0;z-index:100;@media ", "{max-width:350px;height:551px;}"], mediaQueries.largeTablet);
var StyledModalContainer = styled(ModalContainer).withConfig({
  displayName: "alpineiq-terms__StyledModalContainer",
  componentId: "sc-e2d5fk-0"
})(["", ""], modalContainerStyles);
var TitleText = styled(Text).withConfig({
  displayName: "alpineiq-terms__TitleText",
  componentId: "sc-e2d5fk-1"
})(["font-size:26px;padding:22px 0;display:block;font-weight:bold;color:var(--dcm-color-text-primary,", ");"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primaryBlack;
});
var ModalContent = styled.div.withConfig({
  displayName: "alpineiq-terms__ModalContent",
  componentId: "sc-e2d5fk-2"
})(["display:flex;flex-direction:column;align-items:center;justify-content:flex-start;margin:0 100px 36px;padding-top:50px;@media ", "{margin:0 30px 45px;padding-top:41px;}"], mediaQueries.largeTablet);
var StyledAgreeButton = styled(Button).withConfig({
  displayName: "alpineiq-terms__StyledAgreeButton",
  componentId: "sc-e2d5fk-3"
})(["margin:9px auto 19px;font-size:12px;width:153px;height:39px;"]);
var CheckoutText = styled(Text).withConfig({
  displayName: "alpineiq-terms__CheckoutText",
  componentId: "sc-e2d5fk-4"
})(["color:#6d747b;font-size:13px;line-height:24px;", " ", " ", ""], space, width, fontSize);
var TermsText = styled(CheckoutText).withConfig({
  displayName: "alpineiq-terms__TermsText",
  componentId: "sc-e2d5fk-5"
})(["padding-bottom:20px;font-size:12px;text-align:center;line-height:165%;color:", ";@media ", "{font-size:13px;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.grey[35];
}, mediaQueries.largeTablet);